<template>
    <div class="footer-wrap">
        <div class="footer-map">
            <div class="wrapCenter">
                <div class="footer_logo">
                    <img src="../assets/img/logo4.png"/>
                </div>
                <div class="footer_maps" v-for="(item, index) in mapList" :key="index">
                    <dl>
                        <dt> {{ item.title }} </dt>
                        <dd v-for="(child, index2) in item.childs" :key="index2" @click="pageSwitch()">
                            <router-link :to="{path: child.url}"> {{ child.name }} </router-link>
                        </dd>
                    </dl>
                </div>
                <div class="footer-contact">
                    <div class="footer-tel">
                        <img src="../assets/img/contact.png"/>在线客服
                    </div>
                    <p class="p1">400-037-0368</p>
                    <p class="p2">24小时全国热线</p>
                </div>
            </div>
            
        </div>
        <div class="footer-copyright">
            <div class="wrapCenter">
                <p class="p1">2019-2025 TANGMAI 版权所有 <a href="http://www.beian.miit.gov.cn">粤ICP备15028218号-1</a> | 隐私政策 | 用户使用协议 | 联系方式：400-037-0368</p>
                <p class="p2">关注我们：<a href="#" data-toggle="modal" data-target="#modalWechat"><img src="../assets/img/footer_icon1.png"/></a>
                <a href="#"><img src="../assets/img/footer_icon2.png"/></a>
                <a href="http://weibo.com/tangmaikeji"><img src="../assets/img/footer_icon3.png"/></a>
                <a href="https://tangmai.tmall.com/"><img src="../assets/img/footer_icon4.png"/></a>
                <a href="http://mall.jd.com/index-149026.html"><img src="../assets/img/footer_icon5.png"/></a> | 
                <img src="../assets/img/footer_icon6.png"/> 中国</p>
            </div>
        </div>

        <!-- 微信公众号 -->
        <div class="modal fade" id="modalWechat" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <img src="../assets/img/wechat.png"  data-dismiss="modal">
            </div>
        </div>
    </div>
    
</template>
<script>
    export default{
        data(){
            return {
                mapList:[{
                    title:"了解与购买",
                    childs:[{
                        name:"有线耳机",
                        url: ""
                    },{
                        name:"蓝牙耳机",
                        url: ""
                    },{
                        name:"配件",
                        url: ""
                    }]
                },{
                    title:"关于唐麦",
                    childs:[{
                        name:"关于我们",
                        url: "/about/culture"
                    // },{
                    //     name:"加入唐麦",
                    //     url: "/about/join"
                    },{
                        name:"联系我们",
                        url: "/about/contact"
                    }]
                // }, {
                //     title:"服务支持",
                //     childs:[{
                //         name:"防伪查询",
                //         url: "/server/security"
                //     },{
                //         name:"售后政策",
                //         url: "/server"
                //     },{
                //         name:"线下网点",
                //         url: "/server"
                //     }]
                }],
                mobileMapList:[
                    {
                        name: "天猫店",
                        url: "https://tangmai.tmall.com"
                    },{
                        name: "淘宝店",
                        url: "https://tangmaizhengpin.taobao.com/"
                    },{
                        name: "京东店",
                        url: "http://mall.jd.com/index-149026.html"
                    }
                ]
            }
            
        },
        methods:{
            pageSwitch(){
                this.$emit("pageSwitch");
            }
        }
    }
</script>
<style scoped>
    .wrapCenter{
        width: 1100px;
        overflow: hidden;
    }
    .footer-wrap{
        background: #1d191a;
        border-top: 1px #5f5e5c solid;
    }

    .footer_logo{
        width: 105px;
        float: left;
        margin-right: 230px;
    }

    .footer_logo img{
        width: 100%;
    }

    .footer_maps{
        float: left;
        margin-right: 80px;
    }

    .footer-map{
        padding: 36px 0px;
    }
    dl{
        color: #ffffff;
    }

    dl dt{
        font-size: 14px;
        margin-bottom: 20px;
        /* line-height: 50px; */
    }

    dl dd{
        line-height: 50px;
        font-size: 12px;
    }

    dl dd a{
        color: #a7a3a4;
    }

    .footer-tel{
        border-radius: 19px;
        /* float: right; */
        width: 138px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 10px;
        font-size: 16px;
        background: #ffffff;
    }

    .footer-tel img{
        vertical-align: middle;
        margin-right: 4px;
        margin-top: -2px;
    }


    .footer-contact p{
        color: #ffffff;
        line-height: 24px;
        text-align: center;
    }

    .footer-contact p.p1{
        font-size: 18px;
        margin-top: 16px;
        color: #c8c8c8;
    }

    .footer-contact p.p2{
        font-size: 12px;
        color: #9e9c9d;
    }

    .footer-copyright{
        border-top: 1px #5f5e5c solid;
        height: 60px;
    }

    .footer-copyright p{
        text-align: center;
        line-height: 60px;
        color: #848484;
        
    }

    .footer-copyright a{
        color: #848484;
        
    }

    .footer-copyright .p1{
        /* margin-left: 230px; */
        float: left;
    }

    .footer-copyright .p2{
        float: right;
    }

    .footer-copyright p img{
        margin: 0 3px;
        -ms-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
        filter: grayscale(100%);
    }

    .footer-copyright p img:hover, .footer-copyright p img:focus{
        -ms-filter: grayscale(0%);
        -moz-filter: grayscale(0%);
        -o-filter: grayscale(0%);
        -webkit-filter: grayscale(0%); /* Chrome, Safari, Opera */
        filter: grayscale(0%);
    }

    .footer-link-mobile{
        display: none;
    }

    .modal-dialog{
        width: 300px;
        margin: 30px auto;
    }

    #modalWechat img{
        width: 100%;
    }

    .footer-contact{
        float: right;
    }

    @media (max-width: 768px) {
        .footer-wrap{
            float: left;
            width: 100%;
        }
        .wrapCenter{
            width: 100%;
        }
        .footer_maps{
            display: none;
        }
        .footer-link{
            display: none;
        }

        .row{
            margin: 0px;
        }
        .footer-contact{
            overflow: hidden;
            padding: 0px;
        }

        .footer-link-mobile{
            display: block;
        }

        .footer-link-mobile ul{
            float: left;
            position: relative;
            left: 50%;
            transform: translate(-50%, 0)
        }

        .footer-link-mobile li{
            float: left;
            padding: 0 0.4rem;
            
            border-right: 1px #848484 solid;
            height: 0.6rem;
        }

        .footer-link-mobile li:last-child{
            border-right: none;
        }

        .footer-link-mobile li a{
            color: #848484;
            margin-top: -0.1rem;
            float: left;
            font-size: 0.5rem;
        }

        .footer-map{
            padding: 1.4rem 0;
        }

        .footer-tel{
            float: left;
            position: relative;
            left: 50%;
            transform: translate(-50%);
            margin-top: 1rem;
            font-size: 0.7rem;
        }

        .footer-tel .icon-tel{
            width: 0.7rem;
            height: 0.7rem;
        }

         .footer-time{
             text-align: center;
         }

         .footer-time p{
             float: none;
             border-bottom: none;
             font-size: 0.5rem;
         }

         .footer-copyright{
             font-size: 0.5rem;
             height: auto;
             padding: 10px 0;
         }

         .footer-copyright span{
             display: block;
             font-size: 0.5rem;
         }

         .footer-copyright p{
             line-height: 0.9rem;
             font-size: 0.5rem;
             padding: 0 10px;
         }

         .modal-dialog{
             width: 12rem;
         }
         .footer_logo{
             float: none;
             width: 5.12rem;
             margin: 0 auto;
             display: none;
         }
         .footer-contact{
             float: none;
             margin: 0 auto;
         }
         .footer-contact .footer-tel{
             float: none;
         }
         .footer-copyright .p2{
             float: none;
         }
    }
</style>


// WEBPACK FOOTER //
// src/components/footer2.vue